/** @jsx jsx */
import { jsx } from '@compiled/react';

import CommentAfterContent from '../akcomment-resources/comment-after-content.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const AkCommentAfterContent = () => {
	const {
		isThreadedCommentsEnabled,
		isReplyingToComment,
		hasReplies,
		shouldHighlightComment,
		hasChildren,
	} = useCommentContext();
	if (!isThreadedCommentsEnabled) {
		return null;
	}
	if (hasReplies) {
		return null;
	}
	if (isReplyingToComment) {
		return null;
	}
	if (!hasChildren) {
		return null;
	}

	return <CommentAfterContent isHighlighted={shouldHighlightComment} />;
};

export default AkCommentAfterContent;
